module.exports = {
	"articleTitle1": "Suspension of Munger head prompts student questions ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Munger Graduate Residences",
	"articleLink1": "https://www.michigandaily.com/section/news/munger-residents-seek-answers-merrits-suspension",
	"articleLink2": "https://www.michigandaily.com/section/news/housing-changes-munger-leasing-policy",
	"articleSnippet1": "Apr 14, 2016 ... Dr. Greg Merritt, senior associate director of University Housing, was indefinitely \nsuspended from his duties at Munger Graduate Residences ...",
	"articleSnippet2": "Mar 17, 2016 ... Over Spring Break, the residents of Munger Graduate Residences received a \nsurprising e-mail from University of Michigan administration ...",
	"totalMisc": 1,
	"articleTitle2": "Abrupt change in leasing policy angers Munger residents ",
	"address": "540 Thompson St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160415/del.NEW_.Munger.4.14.16.0106.jpg?itok=BhOnlltH",
			"author": "Delaney Ryan",
			"caption": "Munger Graduate Residence Hall began housing graduate students for the first time in the 2015-2016 academic year."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160318/del.NEW_.Munger.3.17.16.303.jpg?itok=xDrFg4sL",
			"author": "Delaney Ryan",
			"caption": "The Munger Graduate Residence on Thompson St."
		}
	],
	"position": {
		"lat": 42.27455,
		"lng": -83.743581
	},
	"tips": [
		{
			"text": "You have to sneak in with a graduate student to get into the building but the view on the 8th floor is definitely worth it. There's a workout track, hammocks, and the best possible view of the stadium. It's a sweet study spot.",
			"person": "Shivangi Sharma"
		},
		{
			"text": "Sneak into munger, the 8th floor is the best place to study.",
			"person": "Caralyn Ryan"
		}
	],
	"bathroomrating": [
		{
			"rating": 5,
			"bathroom": "8th floor"
		}
	],
	"categories": {
		"dorm": 1,
		"housing": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/munger.json
// module id = 927
// module chunks = 0